import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
export function AppRouter() {
  return <Routes data-id="element-3">
      <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
      <Route path="*" element={<Navigate to="/" replace data-id="element-7" />} data-id="element-6" />
    </Routes>;
}